import config from "../../../config";
import { getlist, post } from "../../../contexts/apicontexts";
import { fetchEmployees, normalizeEmployee } from "../../Tasks/taskService";

const normalizeCustomer = (item) => ({
  id: Number(item?.id ?? item?.Id ?? 0),
  name: String(item?.name ?? item?.Name ?? ""),
  customerCode: String(item?.customerCode ?? item?.CustomerCode ?? ""),
  email: String(item?.email ?? item?.Email ?? ""),
  mobile: String(item?.mobile ?? item?.Mobile ?? ""),
  domain: String(item?.domain ?? item?.Domain ?? ""),
  organizationName: String(item?.organizationName ?? item?.OrganizationName ?? ""),
  userId: String(item?.userId ?? item?.UserId ?? ""),
  empUserId: String(item?.empUserId ?? item?.EmpUserId ?? ""),
  isCurrentCustomer: Boolean(item?.isCurrentCustomer ?? item?.IsCurrentCustomer),
});

const normalizeCustomerUser = (item) => ({
  id: Number(item?.id ?? item?.Id ?? 0),
  customerId: Number(item?.customerId ?? item?.CustomerId ?? 0),
  userId: String(item?.userId ?? item?.UserId ?? item?.identityUserId ?? item?.IdentityUserId ?? ""),
  fullName: String(item?.fullName ?? item?.FullName ?? item?.name ?? item?.Name ?? ""),
  email: String(item?.email ?? item?.Email ?? ""),
  mobile: String(item?.mobile ?? item?.Mobile ?? item?.phoneNumber ?? item?.PhoneNumber ?? ""),
  roleName: String(item?.roleName ?? item?.RoleName ?? "Customer User"),
});

export const fetchAdminTicketEmployees = async () => {
  const items = await fetchEmployees();
  return items.map(normalizeEmployee);
};

export const fetchAdminTicketCustomers = async () => {
  const response = await getlist(`${config.baseurl}Customer/getlist`);
  if (response?.status === 200 && Array.isArray(response.data)) {
    return response.data.map(normalizeCustomer);
  }

  throw new Error(response?.message || "Customer list could not be loaded.");
};

export const fetchAdminTicketCustomerUsers = async (customerId) => {
  const query = customerId ? `?customerId=${encodeURIComponent(customerId)}` : "";
  const response = await getlist(`${config.baseurl}CustomerUser/getlist${query}`);
  if (response?.status === 200 && Array.isArray(response.data)) {
    return response.data.map(normalizeCustomerUser);
  }

  throw new Error(response?.message || "Customer user list could not be loaded.");
};

export const createAdminSupportRequest = async (formState) => {
  const formData = new FormData();
  formData.append("EmployeeUserId", String(formState.employeeUserId || "").trim());
  formData.append("CustomerId", String(Number(formState.customerId || 0)));

  if (String(formState.customerUserId || "").trim()) {
    formData.append("CustomerUserId", String(formState.customerUserId).trim());
  }

  formData.append("Subject", String(formState.subject || "").trim());
  formData.append("DomainUrl", String(formState.domainUrl || "").trim());
  formData.append("Category", String(formState.category || "").trim());
  formData.append("Priority", String(formState.priority || "").trim());
  formData.append("ContactEmail", String(formState.contactEmail || "").trim());
  formData.append("Description", String(formState.description || "").trim());

  (formState.attachmentFiles || []).forEach((file) => {
    formData.append("Files", file);
  });

  return post(`${config.baseurl}Ticket/admin-add`, formData);
};
